import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL, IOrganizationEmailTemplateLogoDto } from '@/dtos';
import { useCurrentOrganization } from '@/modules/core/hooks';

export default () => {
  const {
    observingOrganization: { id },
  } = useCurrentOrganization();

  const mutate = useMutation((file: object) => {
    const formData = new FormData();
    formData.append('file', file as Blob);

    return api.post<IOrganizationEmailTemplateLogoDto>(API_URL.ORGANIZATIONS_LOGO_EMAIL_TEMPLATES, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      params: {
        'organization-id': id,
      },
    });
  });
  return {
    handleSave: mutate.mutateAsync,
    isLoading: mutate.isLoading,
  };
};
